import { useState, useEffect } from 'react';
import { client as apollo } from 'cccisd-apollo';
import shareGroupIdQuery from './shareGroupIdQuery.graphql';

const PRODUCTION_PROJECT_ID = 62;
let cachedProjectId = null;

// Get projectId for SHARE project. If there is no project with SHARE label then return 62 (projectId on production)
const useShareProjectId = () => {
    const [projectId, setProjectId] = useState(cachedProjectId);

    useEffect(() => {
        if (cachedProjectId) {
            return;
        }

        (async () => {
            const result = await apollo.query({
                query: shareGroupIdQuery,
                fetchPolicy: 'network-only',
            });

            const id = result.data.groups.questproject.group.groupId || PRODUCTION_PROJECT_ID;
            setProjectId(id);
            cachedProjectId = id;
        })();
    }, []);

    const loading = !projectId;

    return [projectId, loading];
};

export default useShareProjectId;
